import React from "react";
import Modal from "react-modal";

import ImageCropper from "./ImageCropper";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    zIndex: "9999999",
  },
};

const ImageModal = ({
  modalIsOpen,
  closeModal,
  image,
  onCropImage,
  ratio,
  OriginalImage,
}) => {
  return (
    <div style={{ zIndex: "999999999" }}>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        {image && (
          <ImageCropper
            imgName={image.name}
            onCropImage={onCropImage}
            inputImg={URL.createObjectURL(image)}
            closeModal={closeModal}
            ratio={ratio}
            OriginalImage={OriginalImage}
          />
        )}
      </Modal>
    </div>
  );
};

export default ImageModal;
